module.exports = __webpack_public_path__ + "img/tick.f9f03b73.svg";